import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class WallSupportToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const color = this.toColor(element);
        const type = this.formatType('LWP', 0, 0);
        const support = SimpleSapElement.ELEMENT(type, color);
        return [support];
    }
}